import { optionTitle_shortcuts } from './KeyboardShortcutsOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let KeyboardShortcutsOption: LazyOption = createLazyOption(
    {
        key: 'shortcuts',
        titleStringKey: optionTitle_shortcuts,
        searchTermsStringKey: optionTitle_shortcuts,
        allowedOptionKeys: ['KeyboardShortcuts'],
    },
    lazyFullModule,
    m => m.default
);
export default KeyboardShortcutsOption;
